'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import usePrivacyManagedataCardContent from './usePrivacyManagedataCardContent'
import PrivacyManageDataCard from './PrivacyManageDataCard'

const PrivacyManageDataSection = () => {
  const translate = useTranslate('privacy_center.manage_data_section')
  const manageDataSectionCards = usePrivacyManagedataCardContent()

  return (
    <section className="privacy-center__manage-data-section">
      <h2 className="privacy-center__manage-data-title">{translate('title')}</h2>
      <div className="privacy-center__manage-data-cards-container">
        {manageDataSectionCards.map((card, index) => (
          <PrivacyManageDataCard key={index} {...card} />
        ))}
      </div>
    </section>
  )
}

export default PrivacyManageDataSection
